export default __webpack_public_path__ + "static/media/tele-plan-carousel-3.e0cde702.png";